var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 450 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 184",
  d: "M90 135c0 74.443 60.557 135 135 135s135-60.557 135-135S299.443 0 225 0 90 60.557 90 135z",
  fill: "#cdebfc"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 185",
  d: "M360 135C360 60.557 299.443 0 225 0v270c74.443 0 135-60.557 135-135z",
  fill: "#bfe1fd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 186",
  d: "M0 497a14.991 14.991 0 0015 15h420a14.991 14.991 0 0015-15c0-107.52-87.48-197-195-197h-60C87.48 300 0 389.48 0 497z",
  fill: "#cdebfc"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 187",
  d: "M255 300h-30v212h210a14.991 14.991 0 0015-15c0-107.52-87.48-197-195-197z",
  fill: "#bfe1fd"
})));
export default SvgUser;